var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7803 9.69141C14.0731 9.39858 14.073 8.92377 13.7803 8.63086C13.4874 8.33797 13.0126 8.33797 12.7197 8.63086L10.6494 10.7021V4.75C10.6494 4.33579 10.3136 4 9.89941 4C9.4852 4 9.14941 4.33579 9.14941 4.75V10.7002L7.08008 8.63086C6.78718 8.33797 6.31242 8.33797 6.01953 8.63086C5.72693 8.92378 5.72674 9.39861 6.01953 9.69141L9.37012 13.041C9.66303 13.3337 10.1378 13.3338 10.4307 13.041L13.7803 9.69141Z",
    fill: "#172664"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16H15",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellDownload);
export default __webpack_public_path__ + "static/media/icn_table_cell_download.ccc2700b44dd84dea663a9e99764891c.svg";
export { ForwardRef as ReactComponent };